import React, { useRef, useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { EffectCoverflow, Pagination } from "swiper/modules";
import { useMediaQuery } from "react-responsive";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { getStrapiMedia } from "../../../helpers/tranformers";

const ProjectCarousel = ({ content }) => {
  const [swiperRef, setSwiperRef] = useState(null);
  const timeoutRef = useRef(null);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [isHovered, setIsHovered] = useState(false);

  const startAutoSlide = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (swiperRef && !isHovered) {
      timeoutRef.current = setTimeout(() => {
        swiperRef.slideNext();
      }, 5000);
    }
  };

  const prevHandler = () => {
    swiperRef?.slidePrev();
    startAutoSlide();
  };

  const nextHandler = () => {
    swiperRef?.slideNext();
    startAutoSlide();
  };

  useEffect(() => {
    if (swiperRef) {
      startAutoSlide();
    }

    return () => clearTimeout(timeoutRef.current);
  }, [swiperRef, isHovered]);

  return (
    <div className="section-content" style={{ paddingTop: "36px" }}>
      <div className="about-section-heading center-text" data-aos="fade-up">
        {content?.SectionHeading}
      </div>
      <div
        className="section-heading center-text"
        style={{ marginBottom: "50px" }}
        data-aos="fade-up"
      >
        {/* Discover Our Selected Projects */}
        {content?.SectionTitle}
      </div>

      <div style={{ position: "relative" }}>
        <Swiper
          effect={"coverflow"}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={"auto"}
          loop={true}
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 2,
            slideShadows: true,
          }}
          pagination={true}
          modules={[EffectCoverflow, Pagination]}
          className="mySwiper"
          onSwiper={(swiper) => setSwiperRef(swiper)}
          onSlideChange={() => startAutoSlide()}
        >
          {content?.ProjectImages?.map((image, index) => {
            return (
              <SwiperSlide className="project-slides" key={index}>
                <img
                  src={getStrapiMedia(image?.url)}
                  className="p-img"
                  style={{ cursor: "pointer" }}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>

        {!isMobile && (
          <div
            className="swiper-controls"
            style={{
              position: "absolute",
              bottom: "20px",
              left: "20%",
              transform: "translateX(-50%)",
              zIndex: 1,
              display: "flex",
              gap: "10px",
            }}
          >
            <Button
              className="slider-button-prev"
              onClick={prevHandler}
              style={{ padding: "17px", fontSize: "17px" }}
            >
              <ArrowLeftOutlined />
            </Button>
            <Button
              className="slider-button-next"
              onClick={nextHandler}
              style={{ padding: "17px", fontSize: "17px" }}
            >
              <ArrowRightOutlined />
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectCarousel;
